import styles from './Footer.module.css';
import logo from './logo-club-de-madrid-white.svg';
import Button from '../Button/Button';

export default function Footer() {
  return (<footer className={styles.footer}>

    <div className={styles.container}>
      <div className={styles.col}>
        <div className={styles.brand}>
          <img src={logo} alt="" />
          <a href="https://www.clubmadrid.org">www.clubmadrid.org</a>
        </div>

        <div className={styles.social}>
          <a href="https://twitter.com/ClubdeMadrid?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank" nofollow><i class="fa fa-twitter" aria-hidden="true"></i></a>
          <a href="https://www.instagram.com/club_de_madrid/?hl=es" target="_blank" nofollow><i class="fa fa-instagram" aria-hidden="true"></i></a>
          <a href="https://www.linkedin.com/company/clubdemadrid/?originalSubdomain=es" target="_blank" nofollow><i class="fa fa-linkedin" aria-hidden="true"></i></a>
          <a href="https://www.facebook.com/ClubMadrid/" target="_blank" nofollow><i class="fa fa-facebook" aria-hidden="true"></i></a>
          <a href="https://www.youtube.com/c/ClubdeMadridchannel" target="_blank" nofollow><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
        </div>
      </div>

      <div className={styles.col}>
        <h3>Stay in touch with our latest activities!</h3>
        <Button href="https://lp.constantcontactpages.com/su/GJrovAG/clubdemadrid" text="Subscribe to our newsletter"/>
      </div>

      <div className={styles.col}>
        <a href="http://www.clubmadrid.org/privacy-policy-of-the-world-leadership-alliance-club-madrid/">Privacy Policy</a>
        <a href="http://www.clubmadrid.org/your-secure-data/">Your secure data</a>
        <a href="http://www.clubmadrid.org/cookie-policy/">Cookie Policy</a>
      </div>
    </div>

    </footer>);
}
